
// Elements we need to manage
const applyCheckbox = document.querySelector('.apply-now-checkbox');
const btn = document.querySelector('.button-container');
const applyForm = document.querySelector('.form-apply');

const dummyFields = {
    "Date of Birth": "01/01/1900",
    "Postcode": "1111",
    "Gender": "Indeterminant/ Intersex/ Unspecified",
    "Email (Confirm)": "fake@fake.com",
    "Study load": "Full Time"
}

var courseListDOM = "";
var locationListDOM = "";
var studyloadListDOM = "";

function applyFormUpdates(bool, btnLabel) {
    if (applyForm) {
        var formClass = applyForm.classList;

        // Update local storage and button label
        localStorage.setItem('is-application', bool);
        jQuery('.form-section').closest('.scfForm').find('.scfSubmitButton').val(btnLabel);
        bool ? formClass.add('visible') : formClass.remove('visible');
        if (bool) {
            // Clear default values from apply-only fields
            var fieldschanged = false;
            // DOB
            if (jQuery("label:contains('Date of Birth')").closest('div').find('input').val() == dummyFields["Date of Birth"]) {
                jQuery("label:contains('Date of Birth')").removeClass('active').closest('div').find('input').val('');
            } else {
                fieldschanged = true;
            }
            // Postcode
            if (jQuery("label:contains('Postcode')").closest('div').find('input').val() == dummyFields["Postcode"]) {
                jQuery("label:contains('Postcode')").removeClass('active').closest('div').find('input').val('');
            } else {
                fieldschanged = true;
            }
            // Gender - clear this if the other fields haven't changed
            if (!fieldschanged) {
                jQuery("label:contains('Gender')").removeClass('active').closest('div').find('select').val('');
            }
            // Email confirm - always clear
            jQuery("label:contains('Email (Confirm)')").removeClass('active').closest('div').find('input').val('');

            // Remove auto-copy function from email field
            jQuery("label:contains('Email')").closest('div').find('input').off('input.emailcopier');

            // Hide message field (not used for applications)
            jQuery("label:contains('Message')").closest('div').closest('div').hide();

            jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('select').rules('add', { required: true });
            jQuery("label:contains('Preferred Starting Year')").closest('div').find('select').rules('add', { required: true });
            jQuery("label:contains('Course')").closest('div').find('select').rules('add', { required: true });
            jQuery("label:contains('Study load')").closest('div').find('select').rules('add', { required: true });

            // Show asterisks for the fields that are only mandatory on applications
            jQuery("label:contains('Course') .scfRequired").show();
            jQuery("label:contains('Preferred'):contains('Location') .scfRequired").show();
            jQuery("label:contains('Preferred Starting Year') .scfRequired").show();
            jQuery("label:contains('Study load') .scfRequired").show();

        } else {
            // Add dummy values to any blank apply-only fields 
            // DOB
            if (jQuery("label:contains('Date of Birth')").closest('div').find('input').val() == '') {
                jQuery("label:contains('Date of Birth')").closest('div').find('input').val(dummyFields["Date of Birth"]);
            }
            // Postcode
            if (jQuery("label:contains('Postcode')").closest('div').find('input').val() == '') {
                jQuery("label:contains('Postcode')").closest('div').find('input').val(dummyFields["Postcode"]);
            }
            // Gender
            if (jQuery("label:contains('Gender')").closest('div').find('select').val() == '') {
                jQuery("label:contains('Gender')").closest('div').find('select').val(dummyFields["Gender"]);
            }
            // Email confirm - set to match email field
            if (jQuery("label:contains('Email')").closest('div').find('input').val() == '') {
                jQuery("label:contains('Email (Confirm)')").closest('div').find('select').val(dummyFields["Email (Confirm)"]);
            } else {
                jQuery("label:contains('Email (Confirm)')").closest('div').find('input').val(jQuery("label:contains('Email')").closest('div').find('input').val());
            }

            // Add function to copy from email to confirm field so enquiries can be submitted
            jQuery("label:contains('Email')").closest('div').find('input').on('input.emailcopier', function () {
                jQuery("label:contains('Email (Confirm)')").closest('div').find('input').val(jQuery(this).val());
            });

            // Show message field (not used for applications)
            jQuery("label:contains('Message')").closest('div').closest('div').show();

            jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('select').rules('remove', 'required');
            jQuery("label:contains('Preferred Starting Year')").closest('div').find('select').rules('remove', 'required');
            jQuery("label:contains('Course')").closest('div').find('select').rules('remove', 'required');
            // Hide asterisks for the fields that are only mandatory on applications
            jQuery("label:contains('Course') .scfRequired").hide();
            jQuery("label:contains('Preferred'):contains('Location') .scfRequired").hide();
            jQuery("label:contains('Preferred Starting Year') .scfRequired").hide();
            jQuery("label:contains('Study load') .scfRequired").hide();
        }
    }
}

// conditional check for checkbox
function toggleApplication(el) {
    var $checked = jQuery(el).filter(function () {
        return jQuery(this).prop('checked');
    });
    $checked.val() === 'apply' ?
        applyFormUpdates(true, 'Submit') :
        applyFormUpdates(false, 'Submit');
}

function filterCourseList() {
    // Enable only courses that fall under the currently selected study area

    var courseDropdown = jQuery("label:contains('Course')").closest('div').find('select');
    var selectedStudyArea = jQuery("label:contains('Study Area')").closest('div').find('select option:selected');
    var locationDropdown = jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('select');
    var selectedStudyload = jQuery("label:contains('Study load')").closest('div').find('select option:selected');

    if (jQuery(selectedStudyArea).length > 0 && jQuery(selectedStudyArea).val() != '') {
        var studyAreaName = jQuery(selectedStudyArea).val();
        //remove the course list and replace with the saved one
        jQuery(courseDropdown).remove();
        jQuery("label:contains('Course')").closest('div').find('.scfDropListGeneralPanel').append(courseListDOM.clone());
        //clear the location list while we're at it
        jQuery(locationDropdown).remove();
        jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('.scfDropListGeneralPanel').append(locationListDOM.clone());

        jQuery("label:contains('Preferred'):contains('Location')").removeClass('active');


        //remove courses that aren't in the selected study area
        jQuery("label:contains('Course')").removeClass('active');
        courseDropdown = jQuery("label:contains('Course')").closest('div').find('select');
        jQuery(courseDropdown).val([]);
        jQuery(courseDropdown).find("option").each(function () {
            if (jQuery(this).val() != '') {
                var valueArray = jQuery(this).val().split("|");
                if (valueArray.length > 1) {
                    var studyItems = valueArray[1].split(/\s*,\s*/);
                    if (studyItems.indexOf(studyAreaName) == -1) {
                        jQuery(this).remove();
                    }
                }
            }
        });
    } else {
        //remove current filtering
        jQuery(courseDropdown).remove();
        jQuery("label:contains('Course')").closest('div').find('.scfDropListGeneralPanel').append(courseListDOM.clone());
        jQuery(locationDropdown).remove();
        jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('.scfDropListGeneralPanel').append(locationListDOM.clone());
    }
}

function filterStudyloadList() {
    // Enable only courses that fall under the currently selected study load

    var courseDropdown = jQuery("label:contains('Course')").closest('div').find('select');
    var selectedStudyArea = jQuery("label:contains('Study Area')").closest('div').find('select option:selected');
    var locationDropdown = jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('select');
    var selectedStudyload = jQuery("label:contains('Study load')").closest('div').find('select option:selected');

    if (jQuery(selectedStudyload).length > 0 && jQuery(selectedStudyload).val() != '') {
        var studyloadName = jQuery(selectedStudyload).val();
        //remove the course list and replace with the saved one
        jQuery("label:contains('Course')").closest('div').find('.scfDropListGeneralPanel').append(courseListDOM.clone());
        //clear the location list while we're at it

        //remove courses that aren't in the selected study area
        jQuery("label:contains('Course')").removeClass('active');
        courseDropdown = jQuery("label:contains('Course')").closest('div').find('select');
        jQuery(courseDropdown).val([]);
        jQuery(courseDropdown).find("option").each(function () {
            if (jQuery(this).val() != '') {
                var valueArray = jQuery(this).val().split("|");
                if (valueArray.length > 1) {
                    var studyItems = valueArray[1].split(/\s*,\s*/);
                    if (studyItems.indexOf(studyloadName) == -1) {
                        jQuery(this).remove();
                    }
                }
            }
        });
        // } else {
        // //remove current filtering
        // jQuery(courseDropdown).remove();
        // jQuery("label:contains('Course')").closest('div').find('.scfDropListGeneralPanel').append(courseListDOM.clone());
        // jQuery(locationDropdown).remove();
        // jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('.scfDropListGeneralPanel').append(locationListDOM.clone());
        // }
    }
}


function filterLocation() {
    // Enable only locations that are valid for the currently selected course

    var selectedCourse = jQuery("label:contains('Course')").closest('div').find('select option:selected');
    var locationDropdown = jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('select');
    if (jQuery(selectedCourse).length > 0 && jQuery(selectedCourse).val() != '') {

        //remove the select list and replace with the saved one
        jQuery(locationDropdown).remove();
        jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('.scfDropListGeneralPanel').append(locationListDOM.clone());

        jQuery("label:contains('Preferred'):contains('Location')").removeClass('active');
        locationDropdown = jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('select');
        jQuery(locationDropdown).val([]);
        var valueArray = jQuery(selectedCourse).val().split("|");
        if (valueArray.length >= 3) {
            var locationItems = valueArray[2].split(/\s*,\s*/);
            jQuery(locationDropdown).find("option").each(function () {
                if (jQuery(this).val() != '') {
                    if (locationItems.indexOf(jQuery(this).val()) == -1) {
                        jQuery(this).remove();
                    }
                }
            });
        }
    }
}


jQuery(document).ready(function () {
    var courseguid = '';

    // Set up enquire/apply form on page load
    if (applyForm) {
        // Get the default values for the mandatory-on-apply fields and store them in a dictionary
        // (so we can restore them later if necessary)
        /*for (var fieldName in dummyFields) {
            var fieldInput = jQuery("label:contains('" + fieldName + "')").closest('div').find('input,select');
            dummyFields[fieldName] = fieldInput.val();
        }*/
        //hide the dummy course option
        jQuery("label:contains('Course')").closest('div').find('select option:contains("None selected")').remove();

        //save the full course list for filtering
        courseListDOM = jQuery("label:contains('Course')").closest('div').find('select').clone();
        studyloadListDOM = jQuery("label:contains('Study load')").closest('div').find('select').clone();

        locationListDOM = jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('select').clone();


        //check the register/apply radio (default is register - may be apply on postback)
        toggleApplication(jQuery('.enquiry-type input[type="radio"]'));

        jQuery('.enquiry-type input[type="radio"]').change(function () {
            toggleApplication(this)
        })

        // Disable switch to apply if they haven't come from the course page
        jQuery('.enquiry-type').hide();

        // Add blank option to course list and preselect course if provided in query string
        /*jQuery("label:contains('Course')").closest('div').find('select').prepend("<option value='' selected='selected'></option>");
        jQuery("label:contains('Course')").removeClass('active');*/

        // handle the subject area querystring parameter, if provided
        if (jQuery.urlParam('cfid') != null && jQuery.urlParam('cfid') != "") {
            careerguid = decodeURIComponent(jQuery.urlParam('cfid'));
            // select the career field from the list
            jQuery("label:contains('Study Area')").closest('div').find('select').val(careerguid);

            if (jQuery("label:contains('Study Area')").closest('div').find('select option:selected').length > 0) {
                jQuery("label:contains('Study Area')").addClass('active');
                filterCourseList();
            }
            if (jQuery("label:contains('Study load')").closest('div').find('select option:selected').length > 0) {
                jQuery("label:contains('Study load')").addClass('active');
            }

        }

        // handle the course guid querystring parameter, if provided
        if (jQuery.urlParam('id') != null && jQuery.urlParam('id') != "") {
            courseguid = decodeURIComponent(jQuery.urlParam('id'));
            // select the course from the list
            jQuery("label:contains('Course')").closest('div').find('select option').each(function () {
                if (jQuery(this).val().indexOf(courseguid) > -1) {
                    jQuery(this).attr('selected', 'selected');
                    jQuery(this).closest('.scfDropListBorder').find('label').addClass('active');
                    //if no career field provided, pick one from the course
                    if (jQuery("label:contains('Study Area')").closest('div').find('select').val() == "") {
                        var careerfieldname = jQuery(this).val().split("|")[1].split(",")[0];
                        jQuery("label:contains('Study Area')").closest('div').find('select option[value=""]').removeAttr('selected');
                        jQuery("label:contains('Study Area')").closest('div').find('select option[value="' + careerfieldname + '"]').attr('selected', 'selected')
                        jQuery("label:contains('Study Area')").closest('div').find('input[type="hidden"]').val(careerfieldname);
                        jQuery("label:contains('Study Area')").addClass('active');
                    }
                    //filter the campus dropdown
                    filterLocation();
                }
            });

            jQuery('.enquiry-type').show(); //enable the checkbox to switch from register to apply

        }
        else {
            // Check mandatory radio button
            jQuery('.enquiry-type input[type="radio"]').first().prop("checked", true);
        }

        // Add filter functions to select lists
        /*jQuery("label:contains('Study Area')").closest('div').find('select').change(function () {*/
        jQuery("label:contains('Study Area')").closest('div').on('change', 'select', function () {
            filterCourseList();
            filterStudyloadList();
        });

        /*jQuery("label:contains('Course')").closest('div').find('select').change(function () {*/
        jQuery("label:contains('Course')").closest('div').on('change', 'select', function () {
            filterLocation();
        });

        // Remove confirm email validation message if email not provided
        var hideConfirm = false;
        jQuery('.scfValidationSummary ul li').each(function () {
            if (jQuery(this).html() == "You must provide an email address") {
                hideConfirm = true;
            }
        });
        if (hideConfirm) {
            jQuery('.scfValidationSummary ul li').each(function () {
                if (jQuery(this).html() == "You must confirm your email address") {
                    jQuery(this).hide();
                }
            });
        }

    }
});


// COMPLAINTS REGISTER START
var selectors = {
    firstname: 'div.first-name',
    lastname: 'div.last-name',
    studentID: 'div.student-id',
    someoneElse: '.someone-else',
    ageConsent: '.ageconsent-checkbox',
    international: '.international-student-checkbox',
    address: '.street-address',
    suburb: 'div.suburb',
    postcode: 'div.postcode',
    phone: 'div.daytime-phone'
};

function showAsterisk(container) {
    var label = container.find('label, .scfRadioButtonListLabel').first();
    if (!label.length) return;

    if (!label.find('.required-star').length) {
        label.append('<span class="required-star" style="color:#555;"> *</span>');
    }
}

function hideAsterisk(container) {
    var label = container.find('label, .scfRadioButtonListLabel').first();
    var star = label.find('.required-star');

    if (star.length) {
        star.css('color', '#555');
    }
}

function removeAsterisk(container) {
    var label = container.find('label, .scfRadioButtonListLabel').first();
    label.find('.required-star').remove();
}



function addEFRequired(container, selector) {
    var field = container.find(selector).first();
    if (!field.length) return;

    showAsterisk(container);

    var name = field.attr('name');
    var form = field.closest('form');
    var validator = form.data('validator');

    var message = field.attr('data-val-required');
    if (!message || message.trim() === "") {
        message = "This field is required.";
    }

    field.attr('required', 'required');

    if (validator && validator.settings) {

        var existing = validator.settings.rules[name] || {};
        existing.required = true;
        validator.settings.rules[name] = existing;

        validator.settings.messages[name] = validator.settings.messages[name] || {};
        validator.settings.messages[name].required = message;
    }
    var span = container.find('span[data-valmsg-for="' + name + '"]');

    if (field.val().trim() !== "") {

        field.valid();

        if (!field.valid()) {
            restoreInnerSpan(span, message);

            span.removeClass('field-validation-valid')
                .addClass('field-validation-error')
                .show();

            field.addClass('input-validation-error')
                .css('border-color', '#d93025');
        } else {
            removeEFRequired(container, selector);
        }

        return;
    }

    restoreInnerSpan(span, message);

    span.removeClass('field-validation-valid')
        .addClass('field-validation-error')
        .show();

    field.addClass('input-validation-error')
        .css('border-color', '#d93025');
}




function removeEFRequired(container, selector) {
    var field = container.find(selector).first();
    if (!field.length) return;
    removeAsterisk(container);

    var name = field.attr('name');
    var form = field.closest('form');
    var validator = form.data('validator');

    field.removeAttr('required');

    if (validator && validator.settings) {
        delete validator.settings.rules[name];
        delete validator.settings.messages[name];
    }

    var span = container.find('span[data-valmsg-for="' + name + '"]');
    span.removeClass('field-validation-error')
        .addClass('field-validation-valid')
        .hide()
        .text('');

    field.removeClass('input-validation-error')
        .css('border-color', '');

    if (validator) {
        delete validator.submitted[name];
        delete validator.invalid[name];
        delete validator.errorMap[name];
        delete validator.pending[name];

        validator.errorList = jQuery.grep(validator.errorList, function (err) {
            return err.element.name !== name;
        });
        validator.successList = jQuery.grep(validator.successList, function (el) {
            return el.name !== name;
        });

        validator.element(field);
    }
}

function hideEF(container) {
    var fields = container.find('input, textarea, select');

    fields.each(function () {
        var field = jQuery(this);
        var name = field.attr('name');
        var form = field.closest('form');
        var validator = form.data('validator');

        field.removeAttr('required');

        if (validator && validator.settings && validator.settings.rules[name]) {
            delete validator.settings.rules[name];
        }

        var span = container.find('span[data-valmsg-for="' + name + '"]');
        span.removeClass('field-validation-error')
            .addClass('field-validation-valid')
            .hide();

        field.removeClass('input-validation-error')
            .css('border-color', '');
    });

    container.hide();
}

function restoreInnerSpan(span, message) {
    if (span.find('span').length === 0) {
        span.html('<span>' + message + '</span>');
    }
}

function addRadioValidator(container) {
    var field = container.find('input[type="radio"]').first();
    if (!field.length) return;
    showAsterisk(container);
    var name = field.attr('name');
    var form = field.closest('form');
    var validator = form.data('validator');

    var message = container.find('.scfRadioButtonListLabel, label').first().text().trim();
    if (!message) message = "Please select an option.";

    field.attr('required', 'required');

    if (validator && validator.settings) {
        validator.settings.rules[name] = {
            required: true,
            messages: { required: message }
        };
    }

    var span = container.find('span[data-valmsg-for="' + name + '"]');

    if (container.find('input[type="radio"]:checked').length > 0) {
        removeRadioValidator(container);
        return;
    }

    restoreInnerSpan(span, message);

    span.removeClass('field-validation-valid')
        .addClass('field-validation-error')
        .show();
}

function removeRadioValidator(container) {
    var field = container.find('input[type="radio"]').first();
    if (!field.length) return;
    hideAsterisk(container);
    var name = field.attr('name');
    var form = field.closest('form');
    var validator = form.data('validator');

    field.removeAttr('required');

    if (validator && validator.settings && validator.settings.rules[name]) {
        delete validator.settings.rules[name];
    }

    var span = container.find('span[data-valmsg-for="' + name + '"]');
    span.removeClass('field-validation-error')
        .addClass('field-validation-valid')
        .hide();

    field.removeClass('input-validation-error')
        .css('border-color', '');
}


jQuery(function () {
    if (jQuery.validator) {
        jQuery.validator.addMethod("regex", function (value, element, pattern) {
            var regex = new RegExp(pattern);
            return this.optional(element) || regex.test(value);
        });
    }
});


function CharlimitValidators() {

    if (jQuery('.complaint-evidence').length) {


        var field = jQuery('.complaint-evidence input');
        var span = jQuery('.complaint-evidence [data-valmsg-for]');

        if (field.hasClass('input-validation-error')) {
            span.show();
        } else {
            span.hide();
        }

    }


    if (jQuery('.complaint-concern').length) {

        var field = jQuery('.complaint-concern input');
        var span = jQuery('.complaint-concern [data-valmsg-for]');

        if (field.hasClass('input-validation-error')) {
            span.show();
        } else {
            span.hide();
        }

    }


    if (jQuery('.information-resolution-details').length) {

        var field = jQuery('.information-resolution-details input');
        var span = jQuery('.information-resolution-details [data-valmsg-for]');

        if (field.hasClass('input-validation-error')) {
            span.show();
        } else {
            span.hide();
        }

    }

    if (jQuery('.expected-outcome').length) {

        var field = jQuery('.expected-outcome input');
        var span = jQuery('.expected-outcome [data-valmsg-for]');

        if (field.hasClass('input-validation-error')) {
            span.show();
        } else {
            span.hide();
        }

    }


}


jQuery(function () {

    var form = jQuery("form.complaintsRegister");

    var wait = setInterval(function () {

        var validator = form.data("validator");

        if (validator) {
            clearInterval(wait);

            var field = form.find(".complaint-evidence");

            var name = field.attr("name");
            var max = parseInt(field.attr("maxlength"), 10) - 1;

            validator.settings.rules[name] = {
                required: true,
                maxlength: max
            };

            validator.settings.messages[name] = {
                required: "This field is required.",
                maxlength: "Your message exceeds the maximum length of " + max.toLocaleString() + " Please shorten it before submitting."
            };

            field.on("input", function () {
                var val = field.val();
                if (val.length >= max) {

                    var span = form.find('[data-valmsg-for="' + name + '"]');
                    span
                        .removeClass("field-validation-valid")
                        .addClass("field-validation-error")
                        .show()
                        .text("Your message exceeds the maximum length of " + max.toLocaleString() + " Please shorten it before submitting.");
                }
            });
        }

    }, 50);

});


jQuery(function () {

    var form = jQuery("form.complaintsRegister");

    var wait = setInterval(function () {

        var validator = form.data("validator");

        if (validator) {
            clearInterval(wait);

            var field = form.find(".complaint-concern");

            var name = field.attr("name");
            var max = parseInt(field.attr("maxlength"), 10) - 1;

            validator.settings.rules[name] = {
                required: true,
                maxlength: max
            };

            validator.settings.messages[name] = {
                required: "This field is required.",
                maxlength: "Your message exceeds the maximum length of " + max.toLocaleString() + " Please shorten it before submitting."
            };

            field.on("input", function () {
                var val = field.val();
                if (val.length >= max) {

                    var span = form.find('[data-valmsg-for="' + name + '"]');
                    span
                        .removeClass("field-validation-valid")
                        .addClass("field-validation-error")
                        .show()
                        .text("Your message exceeds the maximum length of " + max.toLocaleString() + " Please shorten it before submitting.");
                }
            });
        }

    }, 50);

});

jQuery(function () {

    var form = jQuery("form.complaintsRegister");

    var wait = setInterval(function () {

        var validator = form.data("validator");

        if (validator) {
            clearInterval(wait);

            var field = form.find(".information-resolution-details");

            var name = field.attr("name");
            var max = parseInt(field.attr("maxlength"), 10) - 1;

            validator.settings.rules[name] = {
                required: true,
                maxlength: max
            };

            validator.settings.messages[name] = {
                required: "This field is required.",
                maxlength: "Your message exceeds the maximum length of " + max.toLocaleString() + " Please shorten it before submitting."
            };

            field.on("input", function () {
                var val = field.val();
                if (val.length >= max) {

                    var span = form.find('[data-valmsg-for="' + name + '"]');
                    span
                        .removeClass("field-validation-valid")
                        .addClass("field-validation-error")
                        .show()
                        .text("Your message exceeds the maximum length of " + max.toLocaleString() + " Please shorten it before submitting.");
                }
            });
        }

    }, 50);

});

jQuery(function () {

    var form = jQuery("form.complaintsRegister");

    var wait = setInterval(function () {

        var validator = form.data("validator");

        if (validator) {
            clearInterval(wait);

            var field = form.find(".expected-outcome");

            var name = field.attr("name");
            var max = parseInt(field.attr("maxlength"), 10) - 1;

            validator.settings.rules[name] = {
                required: true,
                maxlength: max
            };

            validator.settings.messages[name] = {
                required: "This field is required.",
                maxlength: "Your message exceeds the maximum length of " + max.toLocaleString() + " Please shorten it before submitting."
            };

            field.on("input", function () {
                var val = field.val();
                if (val.length >= max) {

                    var span = form.find('[data-valmsg-for="' + name + '"]');
                    span
                        .removeClass("field-validation-valid")
                        .addClass("field-validation-error")
                        .show()
                        .text("Your message exceeds the maximum length of " + max.toLocaleString() + " Please shorten it before submitting.");
                }
            });
        }

    }, 50);

});




function texareaValidatorCharacterLimit(target) {
    var container = target.is('textarea')
        ? target.closest('.scfMultipleLineGeneralPanel')
        : target;

    var field = container.find('textarea').first();
    if (!field.length) return;

    showAsterisk(container);

    var name = field.attr('name');
    var form = field.closest('form');
    var validator = form.data('validator');

    var message = field.attr('data-val-required');
    if (!message || message.trim() === "") {
        message = "This Field is required.";
    }

    field.attr('required', 'required');

    var max = parseInt(field.attr("maxlength"), 10) - 1;

    if (validator && validator.settings) {
        validator.settings.rules[name] = {
            required: true,
            maxlength: max
        };

        validator.settings.messages[name] = {
            required: message,
            maxlength: "Your message exceeds the maximum length of " + max.toLocaleString() + " Please shorten it before submitting."
        };
    }

    var span = container.find('span[data-valmsg-for="' + name + '"]');
    restoreInnerSpan(span, message);

    if (field.val().trim() !== "" && field.val().length <= max) {
        removeTextareaValidator(target);
        return;
    }

    span.removeClass('field-validation-valid')
        .addClass('field-validation-error')
        .show();

    field.addClass('input-validation-error')
        .css('border-color', '#d93025');

    field.on("input", function () {
        var val = field.val();

        if (val.length >= max) {
            var span = form.find('[data-valmsg-for="' + name + '"]');
            span
                .removeClass("field-validation-valid")
                .addClass("field-validation-error")
                .show()
                .text("Your message exceeds the maximum length of " + max.toLocaleString() + " Please shorten it before submitting.");
        }
    });
}





function addEmailValidator() {
    var container = jQuery('.email-address');
    var field = container.find('input[type="email"]');
    var name = field.attr('name');
    var form = field.closest('form');
    var validator = form.data('validator');
    var message = "Enter your email address (required)";

    showAsterisk(container);
    field.attr('required', 'required');

    if (validator && validator.settings) {
        var existing = validator.settings.rules[name] || {};

        existing.required = true;

        validator.settings.messages[name] = validator.settings.messages[name] || {};
        validator.settings.messages[name].required = message;

        validator.settings.rules[name] = existing;
    }

    var span = container.find('span[data-valmsg-for="' + name + '"]');

    if (field.val().trim() !== "") {

        field.valid();

        if (!field.valid()) {
            span.text(field.data('val-regex'))
                .removeClass('field-validation-valid')
                .addClass('field-validation-error')
                .show();

            field.addClass('input-validation-error')
                .css('border-color', '#d93025');
        } else {
            removeEmailValidator();
        }

        return;
    }

    restoreInnerSpan(span, message);

    span.removeClass('field-validation-valid')
        .addClass('field-validation-error')
        .show();

    field.addClass('input-validation-error')
        .css('border-color', '#d93025');
}



function removeEmailValidator() {
    var container = jQuery('.email-address');
    var field = container.find('input[type="email"]');
    var name = field.attr('name');
    var form = field.closest('form');
    var validator = form.data('validator');
    hideAsterisk(container);
    field.removeAttr('required');

    if (validator && validator.settings && validator.settings.rules[name]) {
        delete validator.settings.rules[name];
    }

    var span = container.find('span[data-valmsg-for="' + name + '"]');
    span.removeClass('field-validation-error')
        .addClass('field-validation-valid')
        .hide();

    field.removeClass('input-validation-error')
        .css('border-color', '');
}

function addTextareaValidator(target) {
    var container = target.is('textarea')
        ? target.closest('.scfMultipleLineGeneralPanel')
        : target;

    var field = container.find('textarea').first();
    if (!field.length) return;
    showAsterisk(container);
    var name = field.attr('name');
    var form = field.closest('form');
    var validator = form.data('validator');

    var message = field.attr('data-val-required');
    if (!message || message.trim() === "") {
        message = "This Field is required.";
    }

    field.attr('required', 'required');

    if (validator && validator.settings) {
        validator.settings.rules[name] = {
            required: true,
            messages: { required: message }
        };
    }

    var span = container.find('span[data-valmsg-for="' + name + '"]');
    restoreInnerSpan(span, message);

    if (field.val().trim() !== "") {
        removeTextareaValidator(target);
        return;
    }

    span.removeClass('field-validation-valid')
        .addClass('field-validation-error')
        .show();

    field.addClass('input-validation-error')
        .css('border-color', '#d93025');
}

function removeTextareaValidator(target) {
    var container = target.is('textarea')
        ? target.closest('.scfMultipleLineGeneralPanel')
        : target;

    var field = container.find('textarea').first();
    if (!field.length) return;
    hideAsterisk(container);

    var name = field.attr('name');
    var form = field.closest('form');
    var validator = form.data('validator');

    field.removeAttr('required');

    if (validator && validator.settings && validator.settings.rules[name]) {
        delete validator.settings.rules[name];
    }

    try { field.rules('remove'); } catch (e) { }

    var span = container.find('span[data-valmsg-for="' + name + '"]');
    span.removeClass('field-validation-error')
        .addClass('field-validation-valid')
        .hide()
        .text('');

    field.removeClass('input-validation-error')
        .css('border-color', '');
}

function showEF(container) {
    container.show();
}

function hideFieldsOnAnonymous() {
    jQuery('.street-address').closest('.scfMultipleLineTextBorder').hide();
    jQuery('.daytime-phone').hide();
    jQuery(selectors.firstname).hide();
    jQuery(selectors.lastname).hide();
    jQuery('.email-address').hide();
    jQuery(selectors.postcode).hide();
    jQuery(selectors.suburb).hide();
}
function showFieldsOnAnonymous() {
    jQuery('.street-address').closest('.scfMultipleLineTextBorder').show();
    jQuery('.daytime-phone').show();
    jQuery(selectors.firstname).show();
    jQuery(selectors.lastname).show();
    jQuery('.email-address').show();
    jQuery(selectors.postcode).show();
    jQuery(selectors.suburb).show();
}

function applyFormRules() {
    // CharlimitValidators();

    const type = jQuery('.studenttype-droplist select').val();
    const concernType = jQuery('.compliant-or-concern select').val();
    const anonymous = jQuery('.concern-radio-button input[type="radio"]:checked').val();

    if (concernType === 'Concern') {
        showEF(jQuery('.concern-radio-button'));
        addRadioValidator(jQuery('.concern-radio-button'));
    } else {
        hideEF(jQuery('.concern-radio-button'));
        removeRadioValidator(jQuery('.concern-radio-button'));

    }

    if (jQuery('.course-code').length) {

        var field = jQuery('.course-code input');
        var span = jQuery('.course-code [data-valmsg-for]');

        if (field.hasClass('input-validation-error')) {
            span.show();
        } else {
            span.hide();
        }

    }

    if (type === 'Member of the Public') {

        hideEF(jQuery('div.student-id'), 'input');
        hideEF(jQuery('div.student-full-name'), 'input');

        hideEF(jQuery('div.campus'), 'input');
        hideEF(jQuery('div.course-code'), 'input');
        hideEF(jQuery('.course-name'));
        hideEF(jQuery('.course-name-lbl'));
        hideEF(jQuery('div.company-name'), 'input');
        hideEF(jQuery('div.epsilon-employer-code'), 'input');
        hideEF(jQuery('.someone-else'));
        hideEF(jQuery('.unit-code-name'));
        hideEF(jQuery('.unit-code-name-lbl'));
        hideEF(jQuery('.international-student-checkbox'));


        if (concernType === 'Concern' && anonymous === 'Yes') {
            removeEmailValidator();
            removeEFRequired(jQuery(selectors.firstname), 'input');
            removeEFRequired(jQuery(selectors.lastname), 'input');
            removeTextareaValidator(jQuery('.street-address'));
            removeEFRequired(jQuery(selectors.suburb), 'input');
            removeEFRequired(jQuery(selectors.postcode), 'input');
            removeEFRequired(jQuery(selectors.phone), 'input');
            removeRadioValidator(jQuery(selectors.ageConsent));
            hideFieldsOnAnonymous();
        } else {
            showFieldsOnAnonymous();
            addEmailValidator();
            addEFRequired(jQuery(selectors.firstname), 'input');
            addEFRequired(jQuery(selectors.lastname), 'input');
            addTextareaValidator(jQuery('.street-address'));

            addEFRequired(jQuery(selectors.suburb), 'input');
            addEFRequired(jQuery(selectors.postcode), 'input');
            addEFRequired(jQuery(selectors.phone), 'input');
            addRadioValidator(jQuery(selectors.ageConsent));
        }


    }

    if (type === 'Parent/Guardian') {

        hideEF(jQuery('div.company-name'), 'input');
        hideEF(jQuery('div.epsilon-employer-code'), 'input');
        hideEF(jQuery('.unit-code-name'));
        hideEF(jQuery('.unit-code-name-lbl'));
        removeEFRequired(jQuery(selectors.studentID), 'input');

        removeEFRequired(jQuery('.campus'), 'input');
        addRadioValidator(jQuery(selectors.international));
        addRadioValidator(jQuery(selectors.someoneElse));

        if (concernType === 'Concern' && anonymous === 'Yes') {
            removeEFRequired(jQuery(selectors.firstname), 'input');
            removeEFRequired(jQuery(selectors.lastname), 'input');
            removeEmailValidator();

            removeTextareaValidator(jQuery('.street-address'));

            removeEFRequired(jQuery(selectors.suburb), 'input');
            removeEFRequired(jQuery(selectors.postcode), 'input');

            removeEFRequired(jQuery(selectors.phone), 'input');
            hideFieldsOnAnonymous();
            hideEF(jQuery('div.student-id'), 'input');
            hideEF(jQuery('div.student-full-name'), 'input');
        } else {
            showFieldsOnAnonymous();

            addEFRequired(jQuery(selectors.firstname), 'input');
            addEFRequired(jQuery(selectors.lastname), 'input');
            addEmailValidator();

            addTextareaValidator(jQuery('.street-address'));
            addEFRequired(jQuery(selectors.suburb), 'input');
            addEFRequired(jQuery(selectors.postcode), 'input');
            addEFRequired(jQuery(selectors.phone), 'input');
        }
    }

    if (type === 'Prospective Student') {

        hideEF(jQuery('.someone-else'));
        hideEF(jQuery('div.student-id'), 'input');
        hideEF(jQuery('div.campus'), 'input');
        hideEF(jQuery('div.course-code'), 'input');
        hideEF(jQuery('.course-name'));
        hideEF(jQuery('.course-name-lbl'));
        hideEF(jQuery('div.company-name'), 'input');
        hideEF(jQuery('div.student-full-name'), 'input');
        hideEF(jQuery('div.epsilon-employer-code'), 'input');
        hideEF(jQuery('.unit-code-name'));
        hideEF(jQuery('.unit-code-name-lbl'));
        if (concernType === 'Concern' && anonymous === 'Yes') {
            removeEmailValidator();
            removeEFRequired(jQuery(selectors.firstname), 'input');
            removeEFRequired(jQuery(selectors.lastname), 'input');
            removeTextareaValidator(jQuery('.street-address'));
            hideFieldsOnAnonymous();

            removeEFRequired(jQuery(selectors.suburb), 'input');
            removeEFRequired(jQuery(selectors.postcode), 'input');
            removeEFRequired(jQuery(selectors.phone), 'input');
            removeRadioValidator(jQuery(selectors.ageConsent));
            removeRadioValidator(jQuery(selectors.international));



        }
        else {
            showFieldsOnAnonymous();

            addEmailValidator();
            addEFRequired(jQuery(selectors.firstname), 'input');
            addEFRequired(jQuery(selectors.lastname), 'input');
            addTextareaValidator(jQuery('.street-address'));
            addEFRequired(jQuery(selectors.suburb), 'input');
            addEFRequired(jQuery(selectors.postcode), 'input');

            addEFRequired(jQuery(selectors.phone), 'input');
            addRadioValidator(jQuery(selectors.ageConsent));
            addRadioValidator(jQuery(selectors.international));


        }

    }

    if (type === 'Employer') {

        hideEF(jQuery('.unit-code-name'));
        hideEF(jQuery('.unit-code-name-lbl'));
        hideEF(jQuery('.international-student-checkbox'));
        // removeEFRequired(jQuery(selectors.studentID), 'input');

        removeEFRequired(jQuery('.campus'), 'input');

        jQuery('div.epsilon-employer-code').show();
        if (jQuery('.epsilon-employer-code').length) {

            var field = jQuery('.epsilon-employer-code input');
            var span = jQuery('.epsilon-employer-code [data-valmsg-for]');

            if (field.hasClass('input-validation-error')) {
                span.show();
            } else {
                span.hide();
            }

        }

        if (concernType === 'Concern' && anonymous === 'Yes') {
            removeEmailValidator();
            removeEFRequired(jQuery('div.company-name'), 'input');
            removeEFRequired(jQuery('div.company-name'), 'input');

            removeEFRequired(jQuery(selectors.phone), 'input');
            removeEFRequired(jQuery(selectors.firstname), 'input');
            removeEFRequired(jQuery(selectors.lastname), 'input');
            removeEFRequired(jQuery(selectors.suburb), 'input');

            removeTextareaValidator(jQuery('.street-address'));
            removeEFRequired(jQuery(selectors.postcode), 'input');

            removeRadioValidator(jQuery('.someone-else'));
            hideFieldsOnAnonymous();
            hideEF(jQuery('div.student-id'), 'input');
            hideEF(jQuery('div.student-full-name'), 'input');


        } else {
            showFieldsOnAnonymous();
            addEmailValidator();

            addEFRequired(jQuery('div.company-name'), 'input');
            addEFRequired(jQuery(selectors.phone), 'input');
            addEFRequired(jQuery(selectors.postcode), 'input');
            addEFRequired(jQuery(selectors.firstname), 'input');
            addEFRequired(jQuery(selectors.suburb), 'input');

            addEFRequired(jQuery(selectors.lastname), 'input');
            addTextareaValidator(jQuery('.street-address'));
            addRadioValidator(jQuery('.someone-else'));

        }
    }

    if (type === 'Past Student') {

        hideEF(jQuery('div.company-name'), 'input');
        hideEF(jQuery('div.student-full-name'), 'input');
        hideEF(jQuery('div.epsilon-employer-code'), 'input');
        hideEF(jQuery('.unit-code-name'));
        hideEF(jQuery('.unit-code-name-lbl'));
        hideEF(jQuery('.someone-else'));
        //removeEFRequired(jQuery(selectors.studentID), 'input');

        addEFRequired(jQuery('.campus'), 'input');
        addRadioValidator(jQuery(selectors.international));

        if (concernType === 'Concern' && anonymous === 'Yes') {
            removeEmailValidator();
            removeEFRequired(jQuery(selectors.firstname), 'input');
            removeEFRequired(jQuery(selectors.lastname), 'input');
            removeTextareaValidator(jQuery('.street-address'));
            removeEFRequired(jQuery(selectors.suburb), 'input');
            removeEFRequired(jQuery(selectors.postcode), 'input');
            removeEFRequired(jQuery(selectors.phone), 'input');
            removeRadioValidator(jQuery(selectors.ageConsent));
            hideFieldsOnAnonymous();
            hideEF(jQuery('.student-id'));



        } else {
            showFieldsOnAnonymous();
            showEF(jQuery('.student-id'));

            addEmailValidator();
            addEFRequired(jQuery(selectors.firstname), 'input');
            addEFRequired(jQuery(selectors.lastname), 'input');
            addTextareaValidator(jQuery('.street-address'));
            addEFRequired(jQuery(selectors.suburb), 'input');
            addEFRequired(jQuery(selectors.postcode), 'input');
            addEFRequired(jQuery(selectors.phone), 'input');
            addRadioValidator(jQuery(selectors.ageConsent));
        }
    }

    if (type === 'Current Student') {

        hideEF(jQuery('div.company-name'), 'input');
        hideEF(jQuery('div.student-full-name'), 'input');
        hideEF(jQuery('div.epsilon-employer-code'), 'input');
        hideEF(jQuery('.someone-else'));

        //  hideEF(jQuery('.student-id'));
        addEFRequired(jQuery(selectors.studentID), 'input');

        addEFRequired(jQuery('.campus'), 'input');

        if (concernType === 'Concern' && anonymous === 'Yes') {
            removeEmailValidator();
            removeEFRequired(jQuery(selectors.firstname), 'input');
            removeEFRequired(jQuery(selectors.lastname), 'input');
            removeTextareaValidator(jQuery('.street-address'));
            removeEFRequired(jQuery(selectors.suburb), 'input');
            removeEFRequired(jQuery(selectors.postcode), 'input');
            removeEFRequired(jQuery(selectors.phone), 'input');
            removeEFRequired(jQuery(selectors.studentID), 'input');
            removeRadioValidator(jQuery(selectors.ageConsent));
            removeRadioValidator(jQuery(selectors.international));
            hideFieldsOnAnonymous();
            hideEF(jQuery('.student-id'));

        } else {
            showFieldsOnAnonymous();
            addEmailValidator();
            addEFRequired(jQuery(selectors.firstname), 'input');
            addEFRequired(jQuery(selectors.lastname), 'input');
            addEFRequired(jQuery(selectors.studentID), 'input');
            addTextareaValidator(jQuery('.street-address'));
            addEFRequired(jQuery(selectors.suburb), 'input');
            addEFRequired(jQuery(selectors.postcode), 'input');
            addEFRequired(jQuery(selectors.phone), 'input');
            addRadioValidator(jQuery(selectors.ageConsent));
            addRadioValidator(jQuery(selectors.international));
        }
    }

    /* ⭐ IMPORTANT: Rebind EF validation so change/blur works */
    jQuery.validator.unobtrusive.parse('.scfForm1');
}


function onChangeFormRules() {
    //  CharlimitValidators();

    const type = jQuery('.studenttype-droplist select').val();
    const concernType = jQuery('.compliant-or-concern select').val();
    const anonymous = jQuery('.concern-radio-button input[type="radio"]:checked').val();

    if (concernType === 'Concern') {
        showEF(jQuery('.concern-radio-button'));
        showAsterisk(jQuery('.concern-radio-button'));
    } else {
        hideEF(jQuery('.concern-radio-button'));
        removeAsterisk(jQuery('.concern-radio-button'));

    }

    if (jQuery('.course-code').length) {

        var field = jQuery('.course-code input');
        var span = jQuery('.course-code [data-valmsg-for]');

        if (field.hasClass('input-validation-error')) {
            span.show();
        } else {
            span.hide();
        }

    }

    if (type === 'Member of the Public') {
        hideEF(jQuery('div.student-id'), 'input');
        hideEF(jQuery('div.student-full-name'), 'input');

        hideEF(jQuery('div.campus'), 'input');
        hideEF(jQuery('div.course-code'), 'input');
        hideEF(jQuery('.course-name'));
        hideEF(jQuery('.course-name-lbl'));
        hideEF(jQuery('div.company-name'), 'input');
        hideEF(jQuery('div.epsilon-employer-code'), 'input');
        hideEF(jQuery('.someone-else'));
        hideEF(jQuery('.unit-code-name'));
        hideEF(jQuery('.unit-code-name-lbl'));
        hideEF(jQuery('.international-student-checkbox'));


        if (concernType === 'Concern' && anonymous === 'Yes') {
            removeAsterisk(jQuery('.email-address'));
            removeAsterisk(jQuery(selectors.firstname), 'input');
            removeAsterisk(jQuery(selectors.lastname), 'input');
            removeAsterisk(jQuery('.street-address').closest(".scfMultipleLineTextBorder"));
            removeAsterisk(jQuery(selectors.suburb), 'input');
            removeAsterisk(jQuery(selectors.postcode), 'input');
            removeAsterisk(jQuery(selectors.phone), 'input');
            removeAsterisk(jQuery(selectors.ageConsent));

            hideFieldsOnAnonymous();

        } else {
            showFieldsOnAnonymous();

            showAsterisk(jQuery('.email-address'));
            showAsterisk(jQuery(selectors.firstname));
            showAsterisk(jQuery(selectors.lastname));
            showAsterisk(jQuery('.street-address').closest(".scfMultipleLineTextBorder"));
            showAsterisk(jQuery(selectors.suburb));
            showAsterisk(jQuery(selectors.postcode));
            showAsterisk(jQuery(selectors.phone));
            showAsterisk(jQuery(selectors.ageConsent));
        }

    }

    if (type === 'Parent/Guardian') {

        hideEF(jQuery('div.company-name'), 'input');
        hideEF(jQuery('div.epsilon-employer-code'), 'input');
        hideEF(jQuery('.unit-code-name'));
        hideEF(jQuery('.unit-code-name-lbl'));

        showAsterisk(jQuery(selectors.international));
        showAsterisk(jQuery(selectors.someoneElse));
        removeAsterisk(jQuery(selectors.ageConsent));


        if (concernType === 'Concern' && anonymous === 'Yes') {
            removeAsterisk(jQuery(selectors.firstname));
            removeAsterisk(jQuery(selectors.lastname));
            removeAsterisk(jQuery('.email-address'));
            removeAsterisk(jQuery('.street-address').closest(".scfMultipleLineTextBorder"));
            removeAsterisk(jQuery(selectors.suburb));
            removeAsterisk(jQuery(selectors.postcode));
            removeAsterisk(jQuery(selectors.phone));
            hideEF(jQuery('div.student-id'), 'input');
            hideEF(jQuery('div.student-full-name'), 'input');

            hideFieldsOnAnonymous();

        } else {
            showFieldsOnAnonymous();

            showAsterisk(jQuery('.email-address'));
            showAsterisk(jQuery(selectors.firstname));
            showAsterisk(jQuery(selectors.lastname));

            showAsterisk(jQuery('.street-address').closest(".scfMultipleLineTextBorder"));
            showAsterisk(jQuery(selectors.suburb));
            showAsterisk(jQuery(selectors.postcode));
            showAsterisk(jQuery(selectors.phone));
        }
    }

    if (type === 'Prospective Student') {

        hideEF(jQuery('.someone-else'));
        hideEF(jQuery('div.student-id'), 'input');
        hideEF(jQuery('div.campus'), 'input');
        hideEF(jQuery('div.course-code'), 'input');
        hideEF(jQuery('div.company-name'), 'input');
        hideEF(jQuery('div.student-full-name'), 'input');
        hideEF(jQuery('div.epsilon-employer-code'), 'input');
        hideEF(jQuery('.unit-code-name'));
        hideEF(jQuery('.unit-code-name-lbl'));
        hideEF(jQuery('.course-name'));
        hideEF(jQuery('.course-name-lbl'));

        if (concernType === 'Concern' && anonymous === 'Yes') {
            removeAsterisk(jQuery(selectors.firstname));
            removeAsterisk(jQuery(selectors.lastname));
            removeAsterisk(jQuery('.street-address').closest(".scfMultipleLineTextBorder"));
            removeAsterisk(jQuery(selectors.suburb));
            removeAsterisk(jQuery(selectors.postcode));
            removeAsterisk(jQuery('.email-address'));
            removeAsterisk(jQuery(selectors.phone));
            removeAsterisk(jQuery(selectors.ageConsent));
            removeAsterisk(jQuery(selectors.international));

            hideFieldsOnAnonymous();


        } else {
            showFieldsOnAnonymous();

            showAsterisk(jQuery(selectors.firstname));
            showAsterisk(jQuery(selectors.lastname));
            showAsterisk(jQuery('.street-address').closest(".scfMultipleLineTextBorder"));
            showAsterisk(jQuery(selectors.suburb));
            showAsterisk(jQuery(selectors.postcode));
            showAsterisk(jQuery('.email-address'));
            showAsterisk(jQuery(selectors.phone));
            showAsterisk(jQuery(selectors.ageConsent));
            showAsterisk(jQuery(selectors.international));
        }

    }

    if (type === 'Employer') {

        hideEF(jQuery('.unit-code-name'));
        hideEF(jQuery('.unit-code-name-lbl'));
        hideEF(jQuery('.international-student-checkbox'));
        //removeAsterisk(jQuery(selectors.studentID));

        removeAsterisk(jQuery('.campus'));
        removeAsterisk(jQuery(selectors.ageConsent));


        jQuery('div.epsilon-employer-code').show();
        if (jQuery('.epsilon-employer-code').length) {

            var field = jQuery('.epsilon-employer-code input');
            var span = jQuery('.epsilon-employer-code [data-valmsg-for]');

            if (field.hasClass('input-validation-error')) {
                span.show();
            } else {
                span.hide();
            }

        }

        if (concernType === 'Concern' && anonymous === 'Yes') {
            removeAsterisk(jQuery('.email-address'));

            removeAsterisk(jQuery('div.company-name'), 'input');
            removeAsterisk(jQuery(selectors.phone), 'input');
            removeAsterisk(jQuery(selectors.firstname), 'input');
            removeAsterisk(jQuery(selectors.lastname), 'input');
            removeAsterisk(jQuery(selectors.suburb), 'input');
            removeAsterisk(jQuery(selectors.postcode), 'input');
            removeAsterisk(jQuery('.street-address').closest(".scfMultipleLineTextBorder"));
            removeAsterisk(jQuery('.someone-else'));

            hideFieldsOnAnonymous();
            hideEF(jQuery('div.student-id'), 'input');
            hideEF(jQuery('div.student-full-name'), 'input');


        } else {
            showFieldsOnAnonymous();

            showAsterisk(jQuery('.email-address'));
            showAsterisk(jQuery('div.company-name'), 'input');
            showAsterisk(jQuery(selectors.phone), 'input');
            showAsterisk(jQuery(selectors.firstname), 'input');
            showAsterisk(jQuery(selectors.lastname), 'input');
            showAsterisk(jQuery(selectors.suburb), 'input');
            showAsterisk(jQuery(selectors.postcode), 'input');
            showAsterisk(jQuery('.street-address').closest(".scfMultipleLineTextBorder"));
            showAsterisk(jQuery('.someone-else'));

        }
    }

    if (type === 'Past Student') {

        hideEF(jQuery('div.company-name'), 'input');
        hideEF(jQuery('div.student-full-name'), 'input');
        hideEF(jQuery('div.epsilon-employer-code'), 'input');
        hideEF(jQuery('.unit-code-name'));
        hideEF(jQuery('.unit-code-name-lbl'));
        hideEF(jQuery('.someone-else'));
        showAsterisk(jQuery('.campus'));
        showAsterisk(jQuery(selectors.international));

        if (concernType === 'Concern' && anonymous === 'Yes') {
            removeAsterisk(jQuery('.email-address'));
            removeAsterisk(jQuery(selectors.firstname));
            removeAsterisk(jQuery(selectors.lastname));
            removeAsterisk(jQuery('.street-address').closest(".scfMultipleLineTextBorder"));
            removeAsterisk(jQuery(selectors.suburb));
            removeAsterisk(jQuery(selectors.postcode));
            removeAsterisk(jQuery(selectors.phone));
            removeAsterisk(jQuery(selectors.ageConsent));
            hideFieldsOnAnonymous();
            hideEF(jQuery('.student-id'));


        } else {
            showFieldsOnAnonymous();


            showAsterisk(jQuery('.email-address'));
            showAsterisk(jQuery(selectors.firstname));
            showAsterisk(jQuery(selectors.lastname));
            showAsterisk(jQuery('.street-address').closest(".scfMultipleLineTextBorder"));
            showAsterisk(jQuery(selectors.suburb));
            showAsterisk(jQuery(selectors.postcode));
            showAsterisk(jQuery(selectors.phone));
            showAsterisk(jQuery(selectors.ageConsent));
        }
    }

    if (type === 'Current Student') {

        hideEF(jQuery('div.company-name'), 'input');
        hideEF(jQuery('div.student-full-name'), 'input');
        hideEF(jQuery('div.epsilon-employer-code'), 'input');
        hideEF(jQuery('.someone-else'));

        // showEF(jQuery('.student-id'));


        // showAsterisk(jQuery(selectors.studentID));

        showAsterisk(jQuery('.campus'));

        if (concernType === 'Concern' && anonymous === 'Yes') {
            removeAsterisk(jQuery('.email-address'));
            removeAsterisk(jQuery(selectors.firstname));
            removeAsterisk(jQuery(selectors.lastname));
            removeAsterisk(jQuery('.street-address').closest(".scfMultipleLineTextBorder"));
            removeAsterisk(jQuery(selectors.suburb));
            removeAsterisk(jQuery(selectors.postcode));
            removeAsterisk(jQuery(selectors.phone));
            removeAsterisk(jQuery(selectors.studentID));
            removeAsterisk(jQuery(selectors.ageConsent));
            removeAsterisk(jQuery(selectors.international));
            hideEF(jQuery('.student-id'));

            hideFieldsOnAnonymous();

        } else {
            showFieldsOnAnonymous();

            showAsterisk(jQuery(selectors.firstname));
            showAsterisk(jQuery(selectors.lastname));
            showAsterisk(jQuery('.email-address'));
            showAsterisk(jQuery(selectors.studentID));
            showAsterisk(jQuery('.street-address').closest(".scfMultipleLineTextBorder"));
            showAsterisk(jQuery(selectors.suburb));
            showAsterisk(jQuery(selectors.postcode));
            showAsterisk(jQuery(selectors.phone));
            showAsterisk(jQuery(selectors.ageConsent));
            showAsterisk(jQuery(selectors.international));
        }
    }

    /* ⭐ IMPORTANT: Rebind EF validation so change/blur works */
    jQuery.validator.unobtrusive.parse('.scfForm1');
}



jQuery(document).on("input change", ".scfForm1 input, .scfForm1 textarea, .scfForm1 select", function () {

    var $field = jQuery(this);
    var value = $field.val();

    // If user entered something → clear error
    if (value && value.trim() !== "") {

        // Remove red border
        $field.removeClass("input-validation-error")
            .css("border-color", "");

        // Remove error message span
        var name = $field.attr("name");
        var span = jQuery("span[data-valmsg-for='" + name + "']");
        span.removeClass("field-validation-error")
            .addClass("field-validation-valid")
            .hide()
            .text("");

        // Reset validator state for this field only
        var form = $field.closest("form");
        var validator = form.data("validator");

        if (validator) {
            delete validator.invalid[name];
            delete validator.submitted[name];
            delete validator.errorMap[name];

            validator.errorList = jQuery.grep(validator.errorList, function (err) {
                return err.element.name !== name;
            });
        }
    }
});

function resetDynamicValidation() {

    jQuery('.required-star').remove();

    jQuery('.scfSingleLineTextBox, .scfMultipleLineTextBox, select, input')
        .removeAttr('required');

    jQuery('.input-validation-error')
        .removeClass('input-validation-error')
        .css('border-color', '');

    jQuery('.field-validation-error')
        .removeClass('field-validation-error')
        .addClass('field-validation-valid')
        .hide()
        .text('');

    var validator = jQuery(".scfForm1").data("validator");
    if (validator) {
        validator.resetForm();
    }
}



function submitComplaintsRegister() {
    applyFormRules();
    applyAccessibilityVisibility();
    applySomeoneElseVisibility();
    showAllFieldValidationMessages();


}

jQuery(document).on("formField:rendered", function () {
    applyFormRules();
    applyAccessibilityVisibility(); applySomeoneElseVisibility();
});


jQuery(document).on('change', '.accessibility-checkbox', function () {
    applyAccessibilityVisibility();
});
function applyAccessibilityVisibility() {
    var val = jQuery('.accessibility-checkbox input[type="radio"]:checked').val();

    if (val === 'No') {
        jQuery('.showhide, .what-support-you-need').hide();
        removeTextareaValidator(jQuery('.what-support-you-need'));
    } else if (val === 'Yes') {
        jQuery('.showhide, .what-support-you-need').show();
        showAsterisk(jQuery(".what-support-you-need").closest(".scfMultipleLineTextBorder"));

        texareaValidatorCharacterLimit(jQuery('.what-support-you-need'));
    }
}

jQuery(document).on('change', '.someone-else', function () {
    applySomeoneElseVisibility();
});
function applySomeoneElseVisibility() {
    var val = jQuery('.someone-else input[type="radio"]:checked').val();
    const type = jQuery('.studenttype-droplist select').val();
    if (type === 'Parent/Guardian' || type === 'Employer') {
        if (val === 'No') {
            hideEF(jQuery('div.student-id'), 'input');
            hideEF(jQuery('div.campus'), 'input');
            hideEF(jQuery('div.course-code'), 'input');
            hideEF(jQuery('.course-name'));
            hideEF(jQuery('.course-name-lbl'));
            hideEF(jQuery('div.student-full-name'), 'input');
        }
        else if (val === 'Yes') {
            //showEF(jQuery('div.student-id'), 'input');
            showEF(jQuery('div.campus'), 'input');
            showEF(jQuery('div.course-code'), 'input');
            showEF(jQuery('.course-name'));
            showEF(jQuery('.course-name-lbl'));
            // showEF(jQuery('div.student-full-name'), 'input');
        }
    }
}

jQuery(function () {
    jQuery.validator.unobtrusive.parse('.scfForm1');
    initialHide();
});

function initialHide() {
    jQuery('.studenttype-droplist, .compliant-or-concern').show();
    jQuery('.scfForm1').children().not('.studenttype-droplist, .compliant-or-concern').hide();

}
function clearAllValidation() {

    // Complaint Concern
    jQuery('.complaint-concern').removeClass('input-validation-error');
    jQuery('.complaint-concern').removeClass('field-validation-error');
    jQuery('.complaint-concern').closest('.scfMultipleLineTextBorder').removeClass('input-validation-error');

    // Complaint Evidence
    jQuery('.complaint-evidence').removeClass('input-validation-error');
    jQuery('.complaint-evidence').removeClass('field-validation-error');
    jQuery('.complaint-evidence').closest('.scfMultipleLineTextBorder').removeClass('input-validation-error');

    // Informal Resolution Details
    jQuery('.information-resolution-details').removeClass('input-validation-error');
    jQuery('.information-resolution-details').removeClass('field-validation-error');
    jQuery('.information-resolution-details').closest('.scfMultipleLineTextBorder').removeClass('input-validation-error');

    // Expected Outcome
    jQuery('.expected-outcome').removeClass('input-validation-error');
    jQuery('.expected-outcome').removeClass('field-validation-error');
    jQuery('.expected-outcome').closest('.scfMultipleLineTextBorder').removeClass('input-validation-error');

    // Complaint Theme (single line)
    jQuery('.complaint-theme input').removeClass('input-validation-error');
    jQuery('.complaint-theme input').removeClass('field-validation-error');
    jQuery('.complaint-theme').removeClass('input-validation-error');

    // Agree Checkbox (radio buttons)
    jQuery('.agree-checkbox input[type="radio"]').removeClass('input-validation-error');
    jQuery('.agree-checkbox input[type="radio"]').removeClass('field-validation-error');
    jQuery('.agree-checkbox').removeClass('input-validation-error');

    // Accessibility Checkbox (radio buttons)
    jQuery('.accessibility-checkbox input[type="radio"]').removeClass('input-validation-error');
    jQuery('.accessibility-checkbox input[type="radio"]').removeClass('field-validation-error');
    jQuery('.accessibility-checkbox').removeClass('input-validation-error');
}
function hideAllFieldValidationMessages() {

    // Complaint Theme
    jQuery('[data-valmsg-for="fxb.00000000-0000-0000-0000-000000000000.Fields[8c071d2d-f26e-420e-ba8f-24da65ee644e].Value"]').hide();

    // Complaint Concern
    jQuery('[data-valmsg-for="fxb.00000000-0000-0000-0000-000000000000.Fields[b9c22dfd-876e-435d-958f-700999a788f3].Value"]').hide();

    // Complaint Evidence
    jQuery('[data-valmsg-for="fxb.00000000-0000-0000-0000-000000000000.Fields[36aecf78-d52f-43e5-8c57-8c6c418bf6b6].Value"]').hide();

    // Informal Resolution Details
    jQuery('[data-valmsg-for="fxb.00000000-0000-0000-0000-000000000000.Fields[a8c6d220-73a6-4313-8dac-2582f8638249].Value"]').hide();

    // Expected Outcome
    jQuery('[data-valmsg-for="fxb.00000000-0000-0000-0000-000000000000.Fields[3bc1b4e9-4785-470a-b2dc-c5f8fed29b09].Value"]').hide();

    // Agree Checkbox (Yes/No)
    jQuery('[data-valmsg-for="fxb.00000000-0000-0000-0000-000000000000.Fields[92e1c379-852c-438c-80a6-ca1b8adbb8db].Value"]').hide();

    // Accessibility Checkbox (Yes/No)
    jQuery('[data-valmsg-for="fxb.00000000-0000-0000-0000-000000000000.Fields[08114f63-3409-483f-a9f4-d559085567df].Value"]').hide();
}
function showAllFieldValidationMessages() {

    // Complaint Theme
    jQuery('[data-valmsg-for="fxb.00000000-0000-0000-0000-000000000000.Fields[8c071d2d-f26e-420e-ba8f-24da65ee644e].Value"]').show();

    // Complaint Concern
    jQuery('[data-valmsg-for="fxb.00000000-0000-0000-0000-000000000000.Fields[b9c22dfd-876e-435d-958f-700999a788f3].Value"]').show();

    // Complaint Evidence
    jQuery('[data-valmsg-for="fxb.00000000-0000-0000-0000-000000000000.Fields[36aecf78-d52f-43e5-8c57-8c6c418bf6b6].Value"]').show();

    // Informal Resolution Details
    jQuery('[data-valmsg-for="fxb.00000000-0000-0000-0000-000000000000.Fields[a8c6d220-73a6-4313-8dac-2582f8638249].Value"]').show();

    // Expected Outcome
    jQuery('[data-valmsg-for="fxb.00000000-0000-0000-0000-000000000000.Fields[3bc1b4e9-4785-470a-b2dc-c5f8fed29b09].Value"]').show();

    // Agree Checkbox (Yes/No)
    jQuery('[data-valmsg-for="fxb.00000000-0000-0000-0000-000000000000.Fields[92e1c379-852c-438c-80a6-ca1b8adbb8db].Value"]').show();

    // Accessibility Checkbox (Yes/No)
    jQuery('[data-valmsg-for="fxb.00000000-0000-0000-0000-000000000000.Fields[08114f63-3409-483f-a9f4-d559085567df].Value"]').show();
}

jQuery(document).on('change', '.studenttype-droplist select', function () {

    hideAllFieldValidationMessages();
    clearAllValidation();

    var categoryVal = jQuery('.studenttype-droplist select').val().trim().replace(/\s+/g, '');;
    if (categoryVal == "CurrentStudent") {
        categoryVal = "535290000";
    }
    else if (categoryVal == "PastStudent") {
        categoryVal = "535290001";
    }
    else if (categoryVal == "Parent/Guardian") {
        categoryVal = "535290002";
    }
    else if (categoryVal == "Employer") {
        categoryVal = "535290003";
    }
    else if (categoryVal == "MemberofthePublic") {
        categoryVal = "535290004";
    }
    else if (categoryVal == "ProspectiveStudent") {
        categoryVal = "535290005";
    }
    jQuery.ajax({
        url: "/StatusService.svc/StatusService/CaseTheme",
        type: "GET",
        success: function (data) {
            try {
                var results = JSON.parse(data["CaseThemeResult"]);
                var filteredResults = results.filter(function (item) {
                    return item.ComplaintType === Number(categoryVal);
                });
                filteredResults.sort(function (a, b) {
                    return a.Themename.localeCompare(b.Themename);
                });

                var container = jQuery('input[data-sc-field-name="Complaint topics"]')
                    .closest('.scfSingleLineTextBorder');


                renderThemeCheckboxList(container, filteredResults, "ThemeId", "Themename");

            } catch (e) {
                console.error("Invalid JSON for Complaint Theme:", data);
            }
        },
        error: function () {
            console.error("Complaint Theme lookup API failed");
        }
    });




});

var originallabel = document.querySelector("[data-sc-field-name='Under 18']")?.closest(".ageconsent-checkbox").querySelector(".scfRadioButtonListLabel").textContent;
var international_label = document.querySelector("[data-sc-field-name='Are you an International Student']")?.closest(".international-student-checkbox").querySelector(".scfRadioButtonListLabel").textContent;


jQuery(document).on('change', '.compliant-or-concern select, .concern-radio-button input[type="radio"]', function () {

    var complaintVal = jQuery('.compliant-or-concern select').val();
    var categoryVal = jQuery('.studenttype-droplist select').val();
    const anonymous = jQuery('.concern-radio-button input[type="radio"]:checked').val();

    if (complaintVal !== "" && categoryVal !== "") {

        const someoneElse = document.querySelector("[data-sc-field-name='Is complaint on behalf of someone else']");
        const someoneElseWrap = someoneElse?.closest(".someone-else");

        const under18 = document.querySelector("[data-sc-field-name='Under 18']");
        const under18Wrap = under18?.closest(".ageconsent-checkbox");

        const emailaddress = document.querySelector("[data-sc-field-name='Email']");
        const emailaddressWrap = emailaddress?.closest(".email-address");

        const internationalStudent = document.querySelector("[data-sc-field-name='Are you an International Student']");

        const internationalStudentWrap = internationalStudent?.closest(".international-student-checkbox");

        const label = under18Wrap?.querySelector(".scfRadioButtonListLabel");
        const internationalStudentlabel = internationalStudentWrap?.querySelector(".scfRadioButtonListLabel");

        const studentType = jQuery('.studenttype-droplist select').val();

        const canReorder = jQuery(document
            .querySelector("[data-sc-field-name='Is complaint on behalf of someone else']")
            .closest(".someone-else")).is(':visible');
        if (studentType === 'Parent/Guardian' || studentType === 'Employer') {
            if (label) label.textContent = "Are they under 18?";

            if (under18Wrap) someoneElseWrap.after(under18Wrap);
            if (internationalStudentWrap) under18Wrap.after(internationalStudentWrap);
            if (internationalStudentlabel) internationalStudentlabel.textContent = "Are they an International Student?";

        }

        else if (studentType === 'Prospective Student' || studentType === 'Member of the Public') {
            if (label) label.textContent = "Are you under 18?";
            emailaddressWrap.after(under18Wrap);
            if (internationalStudentlabel) internationalStudentlabel.textContent = international_label;
        }
        else if (studentType === 'Current Student' || studentType === 'Past Student') {
            if (label) label.textContent = "Were you under 18 at the time the issue occurred?";
            emailaddressWrap.after(under18Wrap);
            if (internationalStudentlabel) internationalStudentlabel.textContent = international_label;

        } else {
            if (label) label.textContent = originallabel;
            if (internationalStudentlabel) internationalStudentlabel.textContent = international_label;
            if (under18Wrap) emailaddressWrap.after(under18Wrap);
        }

        jQuery('.scfForm1').children().show();
        jQuery('.cr-disclaimer').hide();


        jQuery('.other-theme').hide();

        if (complaintVal === 'Complaint') {
            jQuery('.cr-disclaimer').hide();

            clearValuesExcept([
                ".studenttype-droplist",
                ".compliant-or-concern",
                '[data-sc-field-name="Complaint Concern"]',
                '[data-sc-field-name="Complaint Evidence"]',
                '[data-sc-field-name="Expected Outcome"]',
                '[data-sc-field-name="Informal Resolution Details"]',
                '[data-sc-field-name="Agree to Details Shared"]',
                '[data-sc-field-name="Accessibility Support Needed"]',
                '[data-sc-field-name="Complaint topics"]'

            ]);


        } else if (complaintVal === 'Concern') {
            if (anonymous === 'Yes') {
                jQuery('.cr-disclaimer').show();
            }
            clearValuesExcept([
                ".studenttype-droplist",
                ".compliant-or-concern",
                ".concern-radio-button",
                '[data-sc-field-name="Complaint Concern"]',
                '[data-sc-field-name="Complaint Evidence"]',
                '[data-sc-field-name="Expected Outcome"]',
                '[data-sc-field-name="Informal Resolution Details"]',
                '[data-sc-field-name="Agree to Details Shared"]',
                '[data-sc-field-name="Accessibility Support Needed"]',
                '[data-sc-field-name="Complaint topics"]'

            ]);

        }

        jQuery('[data-sc-field-name="Complaint Concern"]').val('');
        jQuery('[data-sc-field-name="Complaint Evidence"]').val('');
        jQuery('[data-sc-field-name="Expected Outcome"]').val('');
        jQuery('[data-sc-field-name="Informal Resolution Details"]').val('');
        jQuery('.agree-checkbox input[type="radio"]').prop('checked', false);
        jQuery('.accessibility-checkbox input[type="radio"]').prop('checked', false);
        jQuery('[data-sc-field-name="Complaint topics"]').val('');
        jQuery('.theme-checkbox-list .theme-check').prop('checked', false);


        jQuery('.showhide, .what-support-you-need').hide();

        jQuery('.showhide, .what-support-you-need').hide();

        onChangeFormRules();
        applyAccessibilityVisibility();
    }
});




function clearValuesExcept(exceptions) {
    var $form = jQuery(".scfForm1");
    var fields = $form.find("input, textarea, select");

    fields.each(function () {
        var $field = jQuery(this);

        // Skip fields inside exceptions
        for (var i = 0; i < exceptions.length; i++) {
            if ($field.closest(exceptions[i]).length > 0) {
                return; // do nothing at all
            }
        }

        // Clear values ONLY for non-exception fields
        if ($field.is("input[type='text'], input[type='tel'], input[type='email'], input[type='number'], textarea")) {
            $field.val("");
        }

        if ($field.is("select")) {
            $field.prop("selectedIndex", 0);
        }

        if ($field.is("input[type='checkbox'], input[type='radio']")) {
            $field.prop("checked", false);
        }

        if ($field.is("input[type='file']")) {
            $field.val("");
        }

        if ($field.closest('[data-sc-field-name="Complaint Concern"]').length === 0) {

            // remove red border
            $field.removeClass("input-validation-error").css("border-color", "");

            // remove error span
            var fieldName = $field.attr("name");
            if (fieldName) {
                var errorSpan = $form.find('[data-valmsg-for="' + fieldName + '"]');
                errorSpan.removeClass("field-validation-error")
                    .addClass("field-validation-valid")
                    .hide()
                    .text("");
            }
        }
    });

}


function setupLookup(labelText, apiUrl, resultKey, listClass, idField, nameField, multiSelect) {

    multiSelect = (typeof multiSelect === "undefined") ? false : multiSelect;

    var textbox = jQuery('label:contains("' + labelText + '")')
        .closest('.scfSingleLineTextBorder')
        .find('input.scfSingleLineTextBox');

    if (!textbox.length) {
        console.warn(labelText + ' textbox not found');
        return;
    }

    var dataList = [];
    var isLoaded = false;

    jQuery.ajax({
        url: apiUrl,
        type: 'GET',
        success: function (data) {
            try {
                dataList = JSON.parse(data[resultKey]);
                isLoaded = true;
            } catch (e) {
                console.error("Invalid JSON from API:", data);
            }
        },
        error: function () {
            console.error(labelText + ' lookup API failed');
        }
    });

    textbox.on("click", function () {
        if (!isLoaded || dataList.length === 0) return;
        showSuggestions(textbox, dataList, listClass, idField, nameField, multiSelect, labelText);
    });

    textbox.on("keyup", function () {
        if (!isLoaded || dataList.length === 0) return;

        var query = textbox.val().toLowerCase();

        var filtered = dataList.filter(function (item) {
            return item[nameField].toLowerCase().indexOf(query) !== -1;
        });

        showSuggestions(textbox, filtered, listClass, idField, nameField, multiSelect, labelText);
    });
}


function showSuggestions(textbox, results, listClass, idField, nameField, multiSelect, labelText) {

    jQuery('.' + listClass).remove();


    var campusRaw = jQuery('div.campus input').val();
    var campusValue = campusRaw ? campusRaw.trim().toLowerCase() : "";


    results.sort(function (a, b) {
        return a[nameField].localeCompare(b[nameField]);
    });

    if (!results.length) {
        var noList = jQuery('<ul class="' + listClass + '"><li class="no-results">No results found</li></ul>');
        textbox.after(noList);

        jQuery(document).on("click", function (e) {
            if (!jQuery(e.target).closest('.' + listClass + ', .scfSingleLineTextBox').length) {
                noList.remove();
            }
        });

        return;
    }

    var list = jQuery('<ul class="' + listClass + '"></ul>');

    var selectedValues = textbox.val()
        ? textbox.val().split(',').map(function (v) { return v.trim(); }).filter(function (v) { return v; })
        : [];

    if (multiSelect) {
        var closeBtn = jQuery('<div class="lookup-close">×</div>');
        list.prepend(closeBtn);

        closeBtn.on("click", function (e) {
            e.stopPropagation();
            list.remove();
        });
    }

    results.forEach(function (item) {
        var isSelected = selectedValues.indexOf(item[nameField]) !== -1;

        var li = jQuery(
            '<li data-id="' + item[idField] + '">' +
            '<input type="checkbox" class="lookup-check" ' + (isSelected ? 'checked' : '') + '>' +
            '<span>' + item[nameField] + '</span>' +
            '</li>'
        );

        list.append(li);
    });

    textbox.after(list);

    if (multiSelect) {

        list.on("click", "li", function (e) {
            e.stopPropagation();

            var checkbox = jQuery(this).find(".lookup-check");
            checkbox.prop("checked", !checkbox.prop("checked"));

            var value = jQuery(this).find("span").text();

            if (checkbox.prop("checked")) {
                if (selectedValues.indexOf(value) === -1) {
                    selectedValues.push(value);
                }
            } else {
                selectedValues = selectedValues.filter(function (v) {
                    return v !== value;
                });
            }

            textbox.val(
                selectedValues
                    .map(function (v) { return v.trim(); })
                    .filter(function (v) { return v.length > 0; })
                    .join(", ")
            );
        });

        jQuery(document).on("click", function (e) {
            if (!jQuery(e.target).closest('.' + listClass + ', .scfSingleLineTextBox').length) {
                list.remove();
            }
        });

        return;
    }

    list.on("click", "li", function () {
        textbox.val(jQuery(this).find("span").text());

        var campusVal = jQuery('div.campus input').val();
        if (campusVal && campusVal.toLowerCase() === 'online') {
            var deptTextbox = jQuery('div.responsible-department input');
            deptTextbox.val("Online");
        }

        list.remove();
    });

    jQuery(document).on("click", function (e) {
        if (!jQuery(e.target).closest('.' + listClass + ', .scfSingleLineTextBox').length) {
            list.remove();
        }
    });
}


jQuery(document).on('change', '.studenttype-droplist select', function () {
    initialHide();
    jQuery('.concern-radio-button input[type="radio"]').prop('checked', false);
    jQuery('.compliant-or-concern select').val("");
});

function renderThemeCheckboxList(container, filteredResults, idField, nameField) {

    container.find(".theme-checkbox-list").remove();

    var wrapper = jQuery('<div class="theme-checkbox-list"></div>');

    filteredResults.forEach(function (item) {
        var li = jQuery(
            '<label class="theme-item">' +
            '<input type="checkbox" class="theme-check" data-id="' + item[idField] + '">' +
            '<span class="checkboxtext">' + item[nameField] + '</span>' +
            '</label>'
        );
        wrapper.append(li);
    });

    container.append(wrapper);
    container.find("input[type=\'text\']").prop("readonly", true);

    wrapper.on("change", ".theme-check", function () {
        updateThemeSelection(container, wrapper);//added
    });
}



function updateThemeSelection(container, wrapper) {
    var selected = [];

    wrapper.find(".theme-check:checked").each(function () {
        selected.push(jQuery(this).siblings("span").text());
    });

    container.find("input[type='text']").val(selected.join(", "));

    var isOther = selected.includes("Other");

    if (isOther) {
        jQuery('.other-theme').show();
        addOtherThemeRequired()
    } else {
        jQuery('.other-theme').hide();
        removeOtherThemeRequired();
    }
}

function addOtherThemeRequired() {
    var field = jQuery('.other-theme .scfSingleLineGeneralPanel input.scfSingleLineTextBox');
    var container = jQuery('.other-theme');
    field.attr('required', 'required');
    if (!container.find('.required-star').length) {
        container.find('label').append('<span class="required-star" style="color:#555;"> *</span>');
    }
    var name = field.attr('name');
    var span = container.find('span[data-valmsg-for="' + name + '"]');
    span.removeClass('field-validation-valid')
        .addClass('field-validation-error')
        .show()
        .html('<span>This field is required.</span>');
    field.addClass('input-validation-error')
        .css('border-color', '#d93025');
}

function removeOtherThemeRequired() {
    var field = jQuery('.other-theme .scfSingleLineGeneralPanel input.scfSingleLineTextBox');
    var container = jQuery('.other-theme');
    field.removeAttr('required');
    container.find('.required-star').remove();
    var name = field.attr('name');
    var span = container.find('span[data-valmsg-for="' + name + '"]');
    span.removeClass('field-validation-error')
        .addClass('field-validation-valid')
        .hide()
        .text('');
    field.removeClass('input-validation-error')
        .css('border-color', '');
}

//form refresh when user click back button
window.addEventListener("pageshow", function (event) {

    if (event.persisted) {
        window.location.reload();
        return;
    }

    // Case 2: Normal back navigation
    const form = jQuery("form")[0];
    if (form) {
        form.reset();
    }
});


jQuery(function () {
    jQuery('input[data-sc-field-name="Complaint topics"]').css({
        visibility: 'hidden',
        height: '0px',
        margin: '0',
        padding: '0',
        border: 'none'
    });



    setupLookup(
        "Campus",
        "/StatusService.svc/StatusService/CaseCampus",
        "CaseCampusResult",
        "lookup-results",
        "CampusId",
        "Campusname"
    );




});

//notes file upload

function initNotesUpload() {

    var maxCount = 4;

    var input = document.querySelector('[data-sc-field-name="Notes"]');
    if (!input) return;

    var list = document.getElementById("file-list-" + input.id);
    var errorBox = document.getElementById("notes-error-" + input.id);



    if (!input || !list || !errorBox) return;

    var selectedFiles = [];

    input.addEventListener("change", function () {

        clearError();

        var allowed = ["jpg", "gif", "png", "pdf", "doc", "docx", "odt", "xls", "xlsx", "msg"];

        Array.from(this.files).forEach(function (file) {

            var ext = file.name.split('.').pop().toLowerCase();

            // Invalid extension
            if (allowed.indexOf(ext) === -1) {
                showError("Only JPG, GIF, PNG, PDF, DOC, DOCX, ODT, XLS, XLSX, MSG files are allowed.");
                return;
            }

            // Max count exceeded
            if (selectedFiles.length >= maxCount) {
                showError("You can upload only " + maxCount + " files.");
                return;
            }

            selectedFiles.push(file);
        });

        renderList();
        rebuildInput();
    });

    function showError(msg) {
        errorBox.textContent = msg;
        errorBox.style.display = "block";
        errorBox.style.color = "red";
    }

    function clearError() {
        errorBox.textContent = "";
        errorBox.style.display = "none";
    }

    function renderList() {
        list.innerHTML = "";

        selectedFiles.forEach(function (file, index) {
            var li = document.createElement("li");

            var nameSpan = document.createElement("span");
            nameSpan.textContent = file.name;

            var closeIcon = document.createElement("span");
            closeIcon.textContent = " ×";
            closeIcon.style.color = "red";
            closeIcon.style.cursor = "pointer";
            closeIcon.style.marginLeft = "8px";

            closeIcon.addEventListener("click", function () {
                selectedFiles.splice(index, 1);
                renderList();
                rebuildInput();
                clearError();
            });

            li.appendChild(nameSpan);
            li.appendChild(closeIcon);
            list.appendChild(li);
        });
    }

    function rebuildInput() {
        if (typeof DataTransfer === "undefined") {
            return;
        }

        var dt = new DataTransfer();

        selectedFiles.forEach(function (f) {
            dt.items.add(f);
        });

        input.files = dt.files;
    }
}

// Run on initial load
document.addEventListener("DOMContentLoaded", initNotesUpload);

jQuery(document).on("sitecore:form:fieldAdded", initNotesUpload);
jQuery(document).on("sitecore:form:renderComplete", initNotesUpload);




//COMPLAINTS REGISTER END
